import React from 'react';
import ReactDom from 'react-dom';
import { isEqual, omit, pick } from 'lodash';
import { dispatchReactComponentUpdate, ReactComponentWrapper, } from './node-class/common/react-node-utils';
import CircleHandle from './node-handle-react/circle-handle';
export var NODE_PRIMARY_COLOR;
(function (NODE_PRIMARY_COLOR) {
    NODE_PRIMARY_COLOR["YELLOW"] = "rgb(255,207,86)";
    NODE_PRIMARY_COLOR["ORANGE"] = "rgb(246,105,3)";
    NODE_PRIMARY_COLOR["PURPLE"] = "rgb(145,86,255)";
    NODE_PRIMARY_COLOR["BLUE"] = "rgb(73,151,255)";
})(NODE_PRIMARY_COLOR || (NODE_PRIMARY_COLOR = {}));
export class BaseNode {
    get oflowNodeDom() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.canvasModel.canvas.canvasDomRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.querySelector) === null || _c === void 0 ? void 0 : _c.call(_b, `[oflow-element-id='${this.id}']`);
    }
    get nodeStyle() {
        return {};
    }
    get nodeClassName() {
        return '';
    }
    constructor({ canvasId, model, config, isDndPreview = false, }) {
        this.primaryColor = NODE_PRIMARY_COLOR.ORANGE;
        this.renderType = 'React';
        this.Handle = CircleHandle;
        this.couldDelete = true;
        this.couldCopy = true;
        this.quickTools = {
            recommendNext: [],
            recommendPrevious: [],
            quickDuplicate: this.couldCopy,
            quickDelete: this.couldDelete,
        };
        this.highlight = false;
        this.nodePortInstanceMap = {};
        this.isDndPreview = false;
        this.configChangeQueue = [];
        this.connectChangeQueue = [];
        this.getAllNextElemens = () => {
            return this.canvasModel.getAllNextElemens(this);
        };
        this.getAllPreviousElements = () => {
            return this.canvasModel.getAllPreviousElements(this);
        };
        // 获取上游元素
        this.getPreviousElements = () => {
            var _a, _b;
            const { id } = this;
            const nodes = (_b = (_a = this.canvasModel
                .batchFindEdgeInstance({ target: id })) === null || _a === void 0 ? void 0 : _a.map(item => {
                return item.sourceNodeInstance;
            })) === null || _b === void 0 ? void 0 : _b.filter(Boolean);
            return { nodes };
        };
        // 获取后置元素
        this.getNextElements = () => {
            var _a;
            const { id } = this;
            const nodes = (_a = this.canvasModel
                .batchFindEdgeInstance({ source: id })) === null || _a === void 0 ? void 0 : _a.map(item => {
                return item.targetNodeInstance;
            }).filter(Boolean);
            return {
                nodes,
            };
        };
        this.triggerConnectChange = () => {
            this.connectChangeQueue.forEach(fn => {
                fn({ previousElements: this.getPreviousElements(), nextElements: this.getNextElements() });
            });
        };
        this.onConnectChange = (fn) => {
            this.connectChangeQueue.push(fn);
        };
        this.offConnectChange = (fn) => {
            var _a;
            const idx = (_a = this.connectChangeQueue) === null || _a === void 0 ? void 0 : _a.findIndex(item => item === fn);
            this.connectChangeQueue.splice(idx, 1);
        };
        this.onConfigChange = (fn) => {
            this.configChangeQueue.push(fn);
        };
        this.offConfigChange = (fn) => {
            var _a;
            const idx = (_a = this.configChangeQueue) === null || _a === void 0 ? void 0 : _a.findIndex(item => item === fn);
            this.configChangeQueue.splice(idx, 1);
        };
        this.sethighlight = (highlight) => {
            const previousValue = this.highlight;
            if (typeof highlight === 'boolean') {
                this.highlight = highlight;
            }
            else {
                this.highlight = highlight(this.highlight);
            }
            if (previousValue !== this.highlight) {
                this.reRender();
            }
        };
        this.setStatusIcon = (statusIcon) => {
            const previousValue = this.statusIcon;
            this.statusIcon = statusIcon;
            if (previousValue !== this.statusIcon) {
                this.reRender();
            }
        };
        this.setNodePorts = (config = this.nodePortsConfig) => {
            const { NodePort } = this;
            config.forEach(config => {
                this.nodePortInstanceMap[config.id] = new NodePort({ config, parentInstance: this });
            });
        };
        this.getPortInstanceById = (portId) => {
            return this.nodePortInstanceMap[portId];
        };
        this.getConfig = () => {
            return Object.assign({}, this.config);
        };
        this.setConfig = (params, forceRender) => {
            var _a, _b, _c, _d;
            let newConfig;
            if (typeof params === 'function') {
                newConfig = Object.assign({}, params(this.config));
            }
            else {
                newConfig = Object.assign({}, params);
            }
            const { config: previousConfig } = this;
            if (!isEqual(newConfig, previousConfig)) {
                this.config = newConfig;
                if (!isEqual(pick(newConfig, ['left', 'top']), pick(previousConfig, ['left', 'top']))) {
                    (_b = (_a = this.canvasModel.canvas) === null || _a === void 0 ? void 0 : _a.batchMoveNodes) === null || _b === void 0 ? void 0 : _b.call(_a, [newConfig]);
                }
                if (!isEqual(omit(newConfig, ['left', 'top']), omit(previousConfig, ['left', 'top']))) {
                    this.reRender();
                    (_c = this.configChangeQueue) === null || _c === void 0 ? void 0 : _c.forEach(changeFn => {
                        changeFn(this.config);
                    });
                }
            }
            else if (forceRender) {
                this.reRender();
                (_d = this.configChangeQueue) === null || _d === void 0 ? void 0 : _d.forEach(changeFn => {
                    changeFn(newConfig);
                });
            }
        };
        // 重新渲染
        this.reactReRender = () => {
            const { highlight, config } = this;
            dispatchReactComponentUpdate(this.oflowNodeDom, Object.assign(Object.assign({}, config), { highlight }));
        };
        this.reactOff = () => {
            var _a, _b, _c;
            if ((_a = this.oflowNodeDom) === null || _a === void 0 ? void 0 : _a.parentElement) {
                (_b = ReactDom === null || ReactDom === void 0 ? void 0 : ReactDom.unmountComponentAtNode) === null || _b === void 0 ? void 0 : _b.call(ReactDom, (_c = this === null || this === void 0 ? void 0 : this.oflowNodeDom) === null || _c === void 0 ? void 0 : _c.parentElement);
            }
        };
        this.reactRender = () => {
            return React.createElement(ReactComponentWrapper, { instance: this, key: this.id });
        };
        this.canvasRender = () => {
            console.info('暂不支持CanvasRender模式');
        };
        this.render = () => {
            if (this.renderType === 'React')
                return this.reactRender();
        };
        this.reRender = () => {
            if (this.renderType === 'React')
                return this.reactReRender();
        };
        this.off = () => {
            if (this.renderType === 'React')
                return this.reactOff();
        };
        this.canvasId = canvasId;
        this.model = model;
        this.canvasModel = model.getCanvasModel(canvasId);
        // @ts-ignore
        const defaultConfig = this.constructor.defaultConfig;
        this.config = Object.assign(Object.assign({}, defaultConfig), config);
        this.id = this.config.id;
        this.isDndPreview = isDndPreview;
        if (!isDndPreview) {
            this.canvasModel.bindCanvasElement(this.id, this);
        }
    }
    get nodePortsConfig() {
        return [];
    }
}
BaseNode.defaultConfig = {};
BaseNode.Render = ({ instance }) => {
    return React.createElement(ReactComponentWrapper, { instance: instance, key: instance.id });
};
export class BaseNodePort {
    constructor({ config, parentInstance }) {
        this.render = () => {
            if (this.parentInstance.renderType === 'React')
                return this.domRender(this);
        };
        this.config = config;
        this.parentInstance = parentInstance;
    }
}
//# sourceMappingURL=common.js.map